import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vertical-select" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "index" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, idx) => {
      return (_openBlock(), _createElementBlock("button", {
        key: idx,
        type: "button",
        class: _normalizeClass(["option", {selected: $data.selected_idx === idx}]),
        disabled: $data.selected_idx !== -1 && $data.selected_idx !== idx,
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onClick: $event => ($options.onAccept(idx))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(idx + 1), 1 /* TEXT */),
        _createVNode(_component_Ellipsis, { class: "title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}